import {Component, HostListener, Inject, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router} from '@angular/router';
import * as $ from '../assets/js/jquery.js';

function _window(): any {
    return window;
}

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy{
    private adaFlag = false;
    private ClearAda = true;
    public hideUCALeftNav = true;
    private _routerSub;
    public isLanding = false;

    @HostListener('keyup', ['$event'])
    keyUp(event: KeyboardEvent) {
        if (!this.adaFlag && event.key === 'Tab') {
            $('p, a, b, s, span, div, td, img, input, select, button, h1,h2, h3').addClass('ada-focus');
            this.adaFlag = true;
        }
    }

    @HostListener('window:click', ['$event'])
    onClick(event: MouseEvent) {
        if (this.adaFlag || this.ClearAda) {
            $('p, a, b, s, span, div, td, img, input, select, button, h1,h2, h3').removeClass('ada-focus');
            this.adaFlag = this.ClearAda = false;
        } else if ($(event.target).hasClass('ada-focus')) {
            $('p, a, b, s, span, div, td, img, input, select, button, h1,h2, h3').removeClass('ada-focus');
            this.adaFlag = false;
        }
    }

    constructor(
        private router: Router,
        private renderer: Renderer2,
        @Inject(DOCUMENT) private document: Document
    ) {
        this.deleteCookie('_elevaate_session_id', '');
    }
    deleteCookie = (name, domain) => document.cookie = `${name}=; expires=Thu, 01-Jan-1970 00:00:01 GMT; path=/`;

    ngOnInit() {
      const hideLeftNavRoutes = ['/subscribe', '/confirmation', '/freshpass-faq', 'foruplus-faq', '/govassist', '/govassist/mobile', '/discount', '/foruplus/terms', '/foruplus/mobile/terms', '/foruplus/mobile/faqs'];
      // ForU+ enrollment page hides the left nav, but /foruplus/manage keeps it
      const b4uPlusEnrollmentRoute = /^\/foruplus(\.html)?($|[?#])/;
      // Native-app webview routes render with no AEM header. server.js drops the header on a
      // full page load (noBanner branch in loadWebApplication), but on client-side navigation the
      // server-injected header persists as a sibling of <app-root>, so hide it here to match.
      const hideAemShellRoutes = ['/govassist/mobile', '/foruplus/mobile'];
      // ForU+ mobile webviews (terms & faqs) drop the footer too; govassist/mobile keeps it.
      const hideAemFooterRoutes = ['/foruplus/mobile'];

      this._routerSub = this.router.events.subscribe((event) => {
        if (event instanceof NavigationStart) {
          // Hide the AEM shell immediately on NavigationStart so any content that AEM's JS
          // libraries dynamically injected is removed before the new component renders, rather
          // than waiting for NavigationEnd and allowing a brief flash.
          const url = event.url;
          if (hideAemShellRoutes.some(route => url.indexOf(route) >= 0)) {
            this.setAemShellVisibility(
              hideAemShellRoutes.some(r => url.indexOf(r) >= 0),
              hideAemFooterRoutes.some(r => url.indexOf(r) >= 0)
            );
          }
        }
        if (event instanceof NavigationCancel || event instanceof NavigationError) {
          // Only restore when the TARGET was a mobile route — that is the only case where
          // NavigationStart would have hidden the shell. Skip the DOM traversal entirely for
          // cancelled or errored navigations that never touched the shell in the first place.
          const targetUrl = event.url;
          if (hideAemShellRoutes.some(route => targetUrl.indexOf(route) >= 0)) {
            const currentUrl = this.router.url;
            this.setAemShellVisibility(
              hideAemShellRoutes.some(route => currentUrl.indexOf(route) >= 0),
              hideAemFooterRoutes.some(route => currentUrl.indexOf(route) >= 0)
            );
          }
        }
        if (event instanceof NavigationEnd) {
          const url = event.urlAfterRedirects;

          this.isLanding = url.indexOf('/subscribe') >= 0;

          this.hideUCALeftNav = hideLeftNavRoutes.some(route => url.indexOf(route) >= 0)
            || b4uPlusEnrollmentRoute.test(url);

          this.setAemShellVisibility(
            hideAemShellRoutes.some(route => url.indexOf(route) >= 0),
            hideAemFooterRoutes.some(route => url.indexOf(route) >= 0)
          );

          window.scrollTo(0, 0);
        }
      });
    }

    // Toggles the AEM header/footer that server.js injects around <app-root>. In the AEM grid the
    // header renders as the sibling(s) before <app-root> and the footer as the sibling(s) after it
    // (see index.html), so we hide/show the preceding siblings (header) and the following siblings
    // (footer) independently — govassist/mobile hides only the header, ForU+ mobile hides both.
    setAemShellVisibility(hideHeader: boolean, hideFooter: boolean) {
      const appRoot = this.document.querySelector('app-root');
      if (!appRoot || !appRoot.parentElement) {
        return;
      }
      const siblings = Array.from(appRoot.parentElement.children);
      const appRootIndex = siblings.indexOf(appRoot);
      siblings.slice(0, appRootIndex).forEach((el: Element) => this.toggleDisplay(el, hideHeader));
      siblings.slice(appRootIndex + 1).forEach((el: Element) => this.toggleDisplay(el, hideFooter));
    }

    private toggleDisplay(el: Element, hidden: boolean) {
      if (hidden) {
        this.renderer.setStyle(el, 'display', 'none');
      } else {
        this.renderer.removeStyle(el, 'display');
      }
    }

    ngOnDestroy() {
      this._routerSub.unsubscribe();
    }
}
